const initialState: {
  params: { [key: string]: any };
  changeNumber?: number
} = {
  params: {},
  changeNumber: 0,
};

export enum reducerActions {
  UPDATE_ITEM = 'UPDATE_ITEM',
  INIT_EMPTY = 'INIT_EMPTY',
}

const objectReducer = (state = initialState, action: {
  type: reducerActions,
  payload?: {
    [key: string]: unknown
  }
}) => {
  const { params = {}, changeNumber = 0 } = state;
  const { payload } = action || {};
  switch (action.type) {
    case reducerActions.INIT_EMPTY:
      return {
        ...initialState,
      };
    case reducerActions.UPDATE_ITEM:
      return {
        ...state,
        changeNumber: changeNumber + 1,
        params: {
          ...params,
          ...payload,
        },
      };
    default:
      return state;
  }
};

export default objectReducer;
